const cache = new Map<string, { width: number; height: number }>();

let measureSvg: SVGSVGElement | null = null;
let measureText: SVGTextElement | null = null;

function ensureMeasureElements(): { svg: SVGSVGElement; text: SVGTextElement } {
  if (!measureSvg) {
    measureSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    measureSvg.setAttribute('style', 'position:absolute;top:-9999px;left:-9999px;visibility:hidden;');
    document.body.appendChild(measureSvg);
  }
  if (!measureText) {
    measureText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    measureSvg.appendChild(measureText);
  }
  return { svg: measureSvg, text: measureText };
}

/**
 * Measure the pixel dimensions of text at a given font size and weight.
 * Results are cached by (text, fontSize, fontWeight) tuple.
 */
export function measureTextSize(
  text: string,
  fontSize: number,
  fontWeight: string,
): { width: number; height: number } {
  const key = `${text}|${fontSize}|${fontWeight}`;
  const cached = cache.get(key);
  if (cached) return cached;

  const { text: textEl } = ensureMeasureElements();
  textEl.setAttribute('font-size', `${fontSize}px`);
  textEl.setAttribute('font-weight', fontWeight);
  textEl.setAttribute('font-family', 'system-ui, -apple-system, sans-serif');
  textEl.textContent = text || ' ';

  const bbox = textEl.getBBox();
  const result = {
    width: Math.ceil(bbox.width),
    height: Math.ceil(bbox.height),
  };
  cache.set(key, result);
  return result;
}

/** Clear the measurement cache (call on theme change). */
export function clearMeasureCache(): void {
  cache.clear();
}
